import { Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import { motion } from "framer-motion";

import "./WemeBackground.scss";
import clsx from "clsx";
import { isMobile } from "react-device-detect";

interface WemeBackgroundProps {
  backgroundElements?: ReactNode;
  children: ReactNode;
  position?: "left" | "right";
  size?: "small" | "medium" | "large";
}

export const WemeBackground: FC<WemeBackgroundProps> = ({ children, position = "left", size = "medium", backgroundElements = <motion.img
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 1 }}
  className="weme-invite-icon"
  src="/weme-logo-white.png"
  alt="WEME icon"
/> }) => {
  return isMobile ?
    <Stack className="weme-background-container-desktop" justifyContent="center" alignItems="center">{children}</Stack> :
    <Stack className="content-container" width="100%" height="100%" direction={position === "right" ? "row" : "row-reverse"} justifyContent="center" alignItems="center">
      <Stack justifyContent="center" alignItems="center" className={clsx("weme-background-container-desktop", size)}>{backgroundElements}</Stack>
      <Stack justifyContent="center" alignItems="center" className={clsx("children", size)}>{children}</Stack>
    </Stack>;
};
